import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Grid,
} from "@mui/material";
import ItemCrear from "./ItemCrear";
import { useDimensions } from "../../../hooks/useDimensions";

/**
 * CustomTableCrear component renders a table displaying order details such as studies, quantities, discounts, and subtotal.
 * @param {object} props - Component props.
 * @param {boolean} props.botomDisable - Flag indicating whether to disable certain functionality.
 * @param {object} [props.order={}] - Order details object.
 * @returns {JSX.Element} React component.
 */
const CostomTableCrear = ({
  botomDisable,
  order = {},
  store,
  branch,
  onProductCountChange,
  totales,
  payment,
  height,
  widthTelefono
}) => {
  const [estudios, setEstudios] = useState([]);

  // Function to retrieve the list of studies
  const getEstudios = (orden) => {
    // Logic to determine which types of studies to show in the table
    // (X-rays, Laboratory, both, or neither type)
    if (orden.Orden) {
      setEstudios(orden?.Orden);
    } else if (!orden.Orden) {
      setEstudios(orden);
    }
  };
  const dimensionWidth = useDimensions("width");
  const Phone = dimensionWidth < 1000;
  const Tabble = height ? height : 480;
  const style = {
    height: dimensionWidth < 1500 ? 300 : Tabble,
    overflow: "auto",
  };
  useEffect(() => {
    getEstudios(order);
  }, [order]);

  return (
    <>
      <Grid style={Phone ? null : style}>
        <TableContainer style={design.Table}>
          <Table stickyHeader size="small">
            {/* Table headers */}
            <TableHead>
              <TableRow>
                <TableCell style={{ ...design.cell, ...design.desc }}>
                  Estudio
                </TableCell>
                <TableCell style={{ ...design.cell, ...design.desc }}>
                  Cantidad
                </TableCell>
                <TableCell style={{ ...design.cell, ...design.desc }}>
                  Desct.
                </TableCell>
                <TableCell style={{ ...design.cell }}>Subtotal</TableCell>
              </TableRow>
            </TableHead>
            {/* Table body */}
            <TableBody>
              {estudios?.map((doc, idx) => (
                <ItemCrear
                  key={doc.id}
                  subtotal={doc.subtotal}
                  quantity={doc.cantidad}
                  descuento={doc.descuento}
                  label={doc.nombre}
                  unitprice={doc.precio}
                  franquicia={store}
                  sucursal={branch.id}
                  botomDisable={botomDisable}
                  all={estudios}
                  id={doc.id}
                  idx={idx}
                  onProductCountChange={onProductCountChange}
                  widthTelefono={widthTelefono}
                />
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>

      <Table>
        <TableRow>
          <TableCell colSpan={2} />
          <TableCell align="right" style={design.sub}>
            Subtotal <br />
            Total <br />
            {payment ? "Método de pago" : null}
          </TableCell>
          <TableCell align="left">
            {totales
              ? totales.subtotal?.toLocaleString("es-MX", {
                  style: "currency",
                  currency: "MXN",
                  currencyDisplay: "symbol",
                })
              : "$0.00"}
            <br />
            {totales
              ? totales.total?.toLocaleString("es-MX", {
                  style: "currency",
                  currency: "MXN",
                  currencyDisplay: "symbol",
                })
              : "$0.00"}{" "}
            <br />
            {payment ? payment : null}
          </TableCell>
        </TableRow>
      </Table>
    </>
  );
};
export default CostomTableCrear;

/**
 * design es un objeto que contiene estilos personalizados.
 * @type {Object}
 */
const design = {
  Table: {
    borderBottom: "2px dashed rgba(0, 81, 140, 0.4)",
    borderTop: "2px dashed rgba(0, 81, 140, 0.4)",
    // height: "45%",
    width: "100%",
    tableLayout:'fixed'
  },
  cell: {
    backgroundColor: "#D9EDFF",
    textAlign: "center",
    fontWeight: "500",
    color: "#093046",
    fontSize: 12,
    fontFamily: "Lexend",
    borderBottom: "2px dashed rgba(0, 81, 140, 0.4)",
    maxWidth: "95%",
  },
  desc: {
    borderRight: "2px dashed rgba(0, 81, 140, 0.4)",
    maxWidth: "95%",
  },
  sub: {
    fontFamily: "Lexend",
    color: "#093046",
    fontSize: 15,
    textAlign: "right",
  },
};
